import { render, staticRenderFns } from "./WarehousesList.vue?vue&type=template&id=3ce07708&scoped=true&"
import script from "./WarehousesList.vue?vue&type=script&lang=js&"
export * from "./WarehousesList.vue?vue&type=script&lang=js&"
import style0 from "./WarehousesList.vue?vue&type=style&index=0&id=3ce07708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce07708",
  null
  
)

export default component.exports